/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetStudentsR200ResponseInnerOnboardingRequiredFromJSON, GetStudentsR200ResponseInnerOnboardingRequiredToJSON, } from './GetStudentsR200ResponseInnerOnboardingRequired';
/**
 * @export
 */
export const GetStudentsR200ResponseInnerAutomatedAudioEnum = {
    Always: 'always',
    Never: 'never',
    Default: 'default'
};
/**
 * @export
 */
export const GetStudentsR200ResponseInnerIdentityProviderEnum = {
    Clever: 'clever',
    Csv: 'csv',
    ClassLink: 'class-link',
    ClassLinkRaw: 'class-link-raw',
    Renaissance: 'renaissance'
};
/**
 * @export
 */
export const GetStudentsR200ResponseInnerReadAloudSupportEnum = {
    Always: 'always',
    Never: 'never',
    Default: 'default'
};
/**
 * @export
 */
export const GetStudentsR200ResponseInnerSourceEnum = {
    Upload: 'upload',
    IdpSync: 'idp_sync',
    Manual: 'manual'
};
/**
 * @export
 */
export const GetStudentsR200ResponseInnerStartingFreckleTextLevelEnum = {
    Er: 'ER',
    _1A: '1A',
    _1B: '1B',
    _1C: '1C',
    _2A: '2A',
    _2B: '2B',
    _2C: '2C',
    _3A: '3A',
    _3B: '3B',
    _3C: '3C',
    _4A: '4A',
    _4B: '4B',
    _4C: '4C',
    _5A: '5A',
    _5B: '5B',
    _5C: '5C',
    _6A: '6A',
    _6B: '6B',
    _6C: '6C',
    _7A: '7A',
    _7B: '7B',
    _7C: '7C',
    _8A: '8A',
    _8B: '8B',
    _8C: '8C',
    _9A: '9A',
    _9B: '9B',
    _9C: '9C',
    _10A: '10A',
    _10B: '10B',
    _10C: '10C',
    _11A: '11A',
    _11B: '11B',
    _11C: '11C',
    _12A: '12A',
    _12B: '12B',
    _12C: '12C'
};
/**
 * Check if a given object implements the GetStudentsR200ResponseInner interface.
 */
export function instanceOfGetStudentsR200ResponseInner(value) {
    if (!('automatedAudio' in value) || value['automatedAudio'] === undefined)
        return false;
    if (!('coinsSpent' in value) || value['coinsSpent'] === undefined)
        return false;
    if (!('coinsToday' in value) || value['coinsToday'] === undefined)
        return false;
    if (!('coinsTotal' in value) || value['coinsTotal'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('grade' in value) || value['grade'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('idpManaged' in value) || value['idpManaged'] === undefined)
        return false;
    if (!('isTeacher' in value) || value['isTeacher'] === undefined)
        return false;
    if (!('lang' in value) || value['lang'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('password' in value) || value['password'] === undefined)
        return false;
    if (!('readAloudSupport' in value) || value['readAloudSupport'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
export function GetStudentsR200ResponseInnerFromJSON(json) {
    return GetStudentsR200ResponseInnerFromJSONTyped(json, false);
}
export function GetStudentsR200ResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'automatedAudio': json['automatedAudio'],
        'classLinkStudentId': json['classLinkStudentId'] == null ? undefined : json['classLinkStudentId'],
        'cleverStudentId': json['cleverStudentId'] == null ? undefined : json['cleverStudentId'],
        'coinsSpent': json['coinsSpent'],
        'coinsToday': json['coinsToday'],
        'coinsTotal': json['coinsTotal'],
        'createdAt': (new Date(json['createdAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'deletedAt': json['deletedAt'] == null ? undefined : (new Date(json['deletedAt'])),
        'diagnosticCompletedAt': json['diagnosticCompletedAt'] == null ? undefined : (new Date(json['diagnosticCompletedAt'])),
        'districtId': json['districtId'] == null ? undefined : json['districtId'],
        'firstName': json['firstName'],
        'grade': json['grade'],
        'gurId': json['gurId'] == null ? undefined : json['gurId'],
        'id': json['id'],
        'identityProvider': json['identityProvider'] == null ? undefined : json['identityProvider'],
        'idpManaged': json['idpManaged'],
        'isTeacher': json['isTeacher'],
        'lang': json['lang'],
        'lastName': json['lastName'],
        'onboardingRequired': json['onboardingRequired'] == null ? undefined : GetStudentsR200ResponseInnerOnboardingRequiredFromJSON(json['onboardingRequired']),
        'password': json['password'],
        'readAloudSupport': json['readAloudSupport'],
        'renaissanceManualRPIdentifier': json['renaissanceManualRPIdentifier'] == null ? undefined : json['renaissanceManualRPIdentifier'],
        'renaissanceRPIdentifier': json['renaissanceRPIdentifier'] == null ? undefined : json['renaissanceRPIdentifier'],
        'sisId': json['sisId'] == null ? undefined : json['sisId'],
        'source': json['source'] == null ? undefined : json['source'],
        'startingFreckleTextLevel': json['startingFreckleTextLevel'] == null ? undefined : json['startingFreckleTextLevel'],
        'storeLimit': json['storeLimit'] == null ? undefined : json['storeLimit'],
        'updatedAt': (new Date(json['updatedAt'])),
        'wordStudyDiagnosticCompletedAt': json['wordStudyDiagnosticCompletedAt'] == null ? undefined : (new Date(json['wordStudyDiagnosticCompletedAt'])),
        'wordStudyDiagnosticLevel': json['wordStudyDiagnosticLevel'] == null ? undefined : json['wordStudyDiagnosticLevel'],
    };
}
export function GetStudentsR200ResponseInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'automatedAudio': value['automatedAudio'],
        'classLinkStudentId': value['classLinkStudentId'],
        'cleverStudentId': value['cleverStudentId'],
        'coinsSpent': value['coinsSpent'],
        'coinsToday': value['coinsToday'],
        'coinsTotal': value['coinsTotal'],
        'createdAt': ((value['createdAt']).toISOString()),
        'createdBy': value['createdBy'],
        'deletedAt': value['deletedAt'] == null ? undefined : (value['deletedAt'].toISOString()),
        'diagnosticCompletedAt': value['diagnosticCompletedAt'] == null ? undefined : (value['diagnosticCompletedAt'].toISOString()),
        'districtId': value['districtId'],
        'firstName': value['firstName'],
        'grade': value['grade'],
        'gurId': value['gurId'],
        'id': value['id'],
        'identityProvider': value['identityProvider'],
        'idpManaged': value['idpManaged'],
        'isTeacher': value['isTeacher'],
        'lang': value['lang'],
        'lastName': value['lastName'],
        'onboardingRequired': GetStudentsR200ResponseInnerOnboardingRequiredToJSON(value['onboardingRequired']),
        'password': value['password'],
        'readAloudSupport': value['readAloudSupport'],
        'renaissanceManualRPIdentifier': value['renaissanceManualRPIdentifier'],
        'renaissanceRPIdentifier': value['renaissanceRPIdentifier'],
        'sisId': value['sisId'],
        'source': value['source'],
        'startingFreckleTextLevel': value['startingFreckleTextLevel'],
        'storeLimit': value['storeLimit'],
        'updatedAt': ((value['updatedAt']).toISOString()),
        'wordStudyDiagnosticCompletedAt': value['wordStudyDiagnosticCompletedAt'] == null ? undefined : (value['wordStudyDiagnosticCompletedAt'].toISOString()),
        'wordStudyDiagnosticLevel': value['wordStudyDiagnosticLevel'],
    };
}
